class Use {
  keyName = 'user'
  set(params: any) {
    localStorage.setItem(this.keyName, params)
  }
  get(): any {
    return localStorage.getItem(this.keyName) || null
  }
  remove() {
    localStorage.removeItem(this.keyName)
  }
  clear() {
    localStorage.clear()
  }
}

export const useUser = () => {
  let useFun = new Use()
  useFun.keyName = 'user_info'
  return useFun
}

export const useToken = () => {
  let useFun = new Use()
  useFun.keyName = 'teacher_token'
  return useFun
}
export const useInfoUser = () => {
  let useFun = new Use()
  useFun.keyName = 'teacher_info'
  return useFun
}
export const useStatusUser = () => {
  let useFun = new Use()
  useFun.keyName = 'StatusUser'
  return useFun
}
export const useCatchUser = () => {
  let useFun = new Use()
  useFun.keyName = 'CatchUser'
  return useFun
}
export const useReviewType = () => {
  let useFun = new Use()
  useFun.keyName = 'reviewType'
  return useFun
}
